import React, { useEffect, useState } from "react"
import { Box, Container, Grid, Typography, Link } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getMegaMenus } from "../../features/megaMenuSlice"

const Footer = () => {
  const dispatch = useDispatch()
  const { list: megaMenu, loading } = useSelector((state) => state.megaMenu)

  useEffect(() => {
    dispatch(getMegaMenus())
  }, [dispatch])

  return (
    <Box
      component='footer'
      sx={{
        // bgcolor: 'background.paper',
        py: 6,
        borderTop: "1px solid",
        borderColor: "divider",
        mt: "auto",
        bgcolor: "primary.main",
        color: "white",
        fontSize: "1.1rem",
      }}
    >
      <Container maxWidth='lg'>
        <Grid className='row' spacing={4}>
          <Grid className='col-sm-3' xs={12} md={2}>
            <Typography variant='subtitle1' gutterBottom sx={{ mb: 3 }}>
              Company
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Link
                component={RouterLink}
                to='/about'
                className='text-white'
                sx={{ mb: 1 }}
              >
                About Us
              </Link>
              <Link
                component={RouterLink}
                to='/services'
                className='text-white'
                sx={{ mb: 1 }}
              >
                Services
              </Link>
              <Link
                component={RouterLink}
                to='/articles'
                className='text-white'
                sx={{ mb: 1 }}
              >
                Latest Blogs
              </Link>
              <Link
                component={RouterLink}
                to='/contact'
                className='text-white'
                sx={{ mb: 1 }}
              >
                Contact Us
              </Link>
            </Box>
          </Grid>
          <Grid className='col-sm-3' xs={12} md={3}>
            <Typography variant='subtitle1' gutterBottom sx={{ mb: 3 }}>
              Our Services
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {!loading &&
                megaMenu?.map((menu) => (
                  <Link
                    component={RouterLink}
                    to='/services/taxation'
                    className='text-white'
                    sx={{ mb: 1 }}
                    variant='subtitle1'
                  >
                    {menu.title}
                  </Link>
                ))}
            </Box>
          </Grid>
          <Grid className='col-sm-3' xs={12} md={2}>
            <Typography variant='subtitle1' gutterBottom sx={{ mb: 3 }}>
              Resources
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Link
                component={RouterLink}
                to='/about'
                className='text-white'
                sx={{ mb: 1 }}
              >
                About Us
              </Link>
              <Link
                component={RouterLink}
                to='/services'
                className='text-white'
                sx={{ mb: 1 }}
              >
                Services
              </Link>
              <Link
                component={RouterLink}
                to='/contact'
                className='text-white'
                sx={{ mb: 1 }}
              >
                Contact Us
              </Link>
            </Box>
          </Grid>

          <Grid className='col-sm-3' xs={12} md={3}>
            <Typography variant='subtitle1' gutterBottom sx={{ mb: 3 }}>
              Office
            </Typography>
            <Typography className='text-white mb-2' variant='subtitle1'>
              <Link href='tel:8818888744' className='text-white'>
                +91 88188-88744
              </Link>
            </Typography>
            <Typography className='text-white mb-2' variant='subtitle1'>
              psrco131@gmail.com
            </Typography>
            <Typography className='text-white' variant='subtitle1'>
              S-75 Yashwant Plaze <br />
              Near Railway Station Indore.
            </Typography>
          </Grid>
        </Grid>
        <Box mt={5}>
          <Typography className='text-white' align='center'>
            © {new Date().getFullYear()} &nbsp;
            <a href='/' className='text-white pb-2'>
              First Legal India
            </a>
            &nbsp; . All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
